function businessReviewCarousel(obj, block, li) {
    $(obj).parent().find(block + ' ' + li).stop(true,true);
    if ($(obj).hasClass('carousel-prev')) {
        liLast = $(obj).parent().find(block + ' ' + li + ':last');
        liLast.prependTo(liLast.parent()).css('margin-left', '-' + liLast.width() + 'px').animate({marginLeft:0});
    } else {
        liFirst = $(obj).parent().find(block + ' ' + li + ':eq(0)');
        liFirst.animate({marginLeft: 0-liFirst.width()}, function() {
            liFirst.css('margin-left', 0).appendTo(liFirst.parent());
        });
    }
}

$(document).ready(function(){
    setInterval(function(){businessReviewCarousel('.carousel-next', '.business-review-carousel','.carousel-item-img')}, 5000);
});